import ImageCropper from './Modals/ImageCropper'
import MobligoToast from './MobligoToast'
import OTPModal from './Modals/OTPModal'
function GlobalModals() {
    return (
        <>
            <ImageCropper ></ImageCropper>
            <MobligoToast></MobligoToast>
            <OTPModal></OTPModal>
        </>
    )
}

export default GlobalModals